import React, { useState } from 'react';

const RefundForm = () => {
  const [formData, setFormData] = useState({
    order_id: '',
    refund_type: 'Full',
    description: ''
  });

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append('order_id', formData.order_id);
    data.append('refund_type', formData.refund_type);
    data.append('description', formData.description);

    try {
      const res = await fetch('https://st.tjdstore.in/api/submit_refund.php', {
        method: 'POST',
        body: data
      });
      const result = await res.json();
      alert('Refund submitted successfully!');
      setFormData({ order_id: '', refund_type: 'Full', description: '' });
    } catch (err) {
      console.error(err);
      alert('Something went wrong while submitting the refund.');
    }
  };

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-header bg-primary text-white">
          Refund Order Form
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>

            <div className="mb-3">
              <label htmlFor="order_id" className="form-label">Order ID</label>
              <input
                type="text"
                className="form-control"
                id="order_id"
                name="order_id"
                value={formData.order_id}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="refund_type" className="form-label">Refund Type</label>
              <select
                className="form-select"
                id="refund_type"
                name="refund_type"
                value={formData.refund_type}
                onChange={handleChange}
                required
              >
                <option value="Full">Full</option>
                <option value="Partial">Partial</option>
              </select>
            </div>

            <div className="mb-3">
              <label htmlFor="description" className="form-label">Description (Optional)</label>
              <textarea
                className="form-control"
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                rows="3"
              />
            </div>

            <button type="submit" className="btn btn-success">
              Submit Refund
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RefundForm;
